<div class="flex flex-col lg:flex-row w-full gap-3 lg:gap-8 2xl:gap-12">
  <!-- Contenuto principale skeleton -->
  <div class="flex flex-col gap-6 w-full">
    <!-- Search skeleton -->
    <div class="w-full max-w-md">
      <div class="w-full h-10 bg-gray-200 animate-pulse rounded"></div>
    </div>

    <!-- Table skeleton -->
    <div class="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <!-- Table header skeleton -->
      <div class="bg-gray-50 border-b border-gray-200 p-4">
        <div class="flex gap-4">
          <div class="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
          <div class="w-32 h-4 bg-gray-200 animate-pulse rounded"></div>
          <div class="w-28 h-4 bg-gray-200 animate-pulse rounded"></div>
          <div class="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
          <div class="w-32 h-4 bg-gray-200 animate-pulse rounded"></div>
          <div class="w-16 h-4 bg-gray-200 animate-pulse rounded"></div>
        </div>
      </div>

      <!-- Table rows skeleton -->
      <div class="divide-y divide-gray-200">
        <!-- Row 1 -->
        <div class="p-4">
          <div class="flex gap-4 items-center">
            <div class="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-32 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-28 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-32 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-16 h-8 bg-gray-200 animate-pulse rounded"></div>
          </div>
        </div>

        <!-- Row 2 -->
        <div class="p-4">
          <div class="flex gap-4 items-center">
            <div class="w-28 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-36 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-32 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-28 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-36 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-16 h-8 bg-gray-200 animate-pulse rounded"></div>
          </div>
        </div>

        <!-- Row 3 -->
        <div class="p-4">
          <div class="flex gap-4 items-center">
            <div class="w-32 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-28 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-20 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-28 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-16 h-8 bg-gray-200 animate-pulse rounded"></div>
          </div>
        </div>

        <!-- Row 4 -->
        <div class="p-4">
          <div class="flex gap-4 items-center">
            <div class="w-26 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-30 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-28 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-24 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-32 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-16 h-8 bg-gray-200 animate-pulse rounded"></div>
          </div>
        </div>

        <!-- Row 5 -->
        <div class="p-4">
          <div class="flex gap-4 items-center">
            <div class="w-30 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-34 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-26 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-22 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-30 h-4 bg-gray-200 animate-pulse rounded"></div>
            <div class="w-16 h-8 bg-gray-200 animate-pulse rounded"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
